import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Divider,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MotiveList from './MotiveList';
import { useIssueContainerStyles } from './styles';

const IssueContainer = ({ ...props }) => {
  const { mobile, issues, product } = props;
  const classes = useIssueContainerStyles({ mobile });

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box width="100%" className={classes.container}>
      {issues.map((issue, index) => (
        <React.Fragment key={index}>
          <Accordion
            expanded={expanded === index}
            onChange={handleChange(index)}
            elevation={0}
            width="100%"
            disabled={issue.disabled}
            className={classes.accordion}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center">
                <img className={classes.icon} src={issue.icon} />
                <Box display="flex" flexDirection="column">
                  <Typography className={classes.title}>
                    {issue.title}{' '}
                  </Typography>
                  <Typography className={classes.subtitle}>
                    {issue.subtitle}{' '}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails classes={{ root: classes.rootDetailAccordion }}>
              <MotiveList
                motives={issue.motives}
                mobile={mobile}
                product={product}
              />
            </AccordionDetails>
          </Accordion>
          <Divider />
        </React.Fragment>
      ))}
    </Box>
  );
};

IssueContainer.propTypes = {
  mobile: PropTypes.bool,
  product: PropTypes.object,
  issues: PropTypes.array,
};

export default IssueContainer;
